import { render } from "./AudioBlock.vue?vue&type=template&id=129e0e3e&scoped=true"
import script from "./AudioBlock.vue?vue&type=script&lang=js"
export * from "./AudioBlock.vue?vue&type=script&lang=js"

import "./AudioBlock.vue?vue&type=style&index=0&id=129e0e3e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-129e0e3e"],['__file',"src/vue/components/AudioBlock.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "129e0e3e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('129e0e3e', __exports__)) {
    api.reload('129e0e3e', __exports__)
  }
  
  module.hot.accept("./AudioBlock.vue?vue&type=template&id=129e0e3e&scoped=true", () => {
    api.rerender('129e0e3e', render)
  })

}


export default __exports__